import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { personalInfo } from '../mock';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    toast({
      title: 'Mensagem Enviada!',
      description: 'Entraremos em contato em breve. Obrigado!',
    });
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-20 px-4" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#1e3a5f' }}>
            Entre em Contato
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estou pronto para ajudar você a realizar seu projeto. Vamos conversar!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <h3 className="text-2xl font-bold mb-6" style={{ color: '#1e3a5f' }}>
                Informações de Contato
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div
                    className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#1e3a5f' }}
                  >
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold" style={{ color: '#1e3a5f' }}>Telefone</p>
                    <p className="text-gray-600">{personalInfo.phone}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div
                    className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#1e3a5f' }}
                  >
                    <Mail className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold" style={{ color: '#1e3a5f' }}>E-mail</p>
                    <p className="text-gray-600">{personalInfo.email}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div
                    className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#1e3a5f' }}
                  >
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold" style={{ color: '#1e3a5f' }}>Localização</p>
                    <p className="text-gray-600">{personalInfo.location}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div
                    className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: '#1e3a5f' }}
                  >
                    <Instagram className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold" style={{ color: '#1e3a5f' }}>Instagram</p>
                    <a
                      href={personalInfo.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 hover:text-[#c17835] transition-colors"
                    >
                      @hotnymota
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <h3 className="text-xl font-bold mb-4" style={{ color: '#1e3a5f' }}>
                Preferência por WhatsApp?
              </h3>
              <p className="text-gray-600 mb-6">
                Clique no botão abaixo para iniciar uma conversa diretamente pelo WhatsApp
              </p>
              <Button
                onClick={() => window.open(`https://wa.me/${personalInfo.whatsapp}`, '_blank')}
                className="w-full py-6 text-lg font-semibold"
                style={{ backgroundColor: '#25D366', color: 'white' }}
              >
                Abrir WhatsApp
              </Button>
            </div>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md">
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#1e3a5f' }}>
              Envie uma Mensagem
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: '#1e3a5f' }}>
                  Nome Completo
                </label>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Seu nome"
                  className="w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: '#1e3a5f' }}>
                  E-mail
                </label>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="seu@email.com"
                  className="w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: '#1e3a5f' }}>
                  Telefone
                </label>
                <Input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="(11) 99999-9999"
                  className="w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: '#1e3a5f' }}>
                  Mensagem
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Conte-me sobre seu projeto..."
                  rows={6}
                  className="w-full"
                />
              </div>

              <Button
                type="submit"
                className="w-full py-6 text-lg font-semibold"
                style={{ backgroundColor: '#1e3a5f', color: 'white' }}
              >
                Enviar Mensagem
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;